<template>
    <!--begin::Toolbar wrapper-->
    <div class="d-flex align-items-stretch flex-shrink-0">
        <!--begin::Spotlight Search-->
        <div class="d-flex align-items-center me-2 me-lg-4">
            <button class="topbar-spotlight-btn" @click="openSpotlight">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                <span class="topbar-spotlight-shortcut">{{ isMac ? '⌥S' : 'Alt+S' }}</span>
            </button>
        </div>
        <!--end::Spotlight Search-->

        <!--begin::Notifications-->
        <!--<div class="d-flex align-items-center ms-1 ms-lg-3">
            <div class="btn btn-icon btn-active-light-primary position-relative w-30px h-30px w-md-40px h-md-40px" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end" data-kt-menu-flip="bottom">
                <span class="svg-icon svg-icon-1">
                    <inline-svg src="/media/icons/duotune/general/gen022.svg"/>
                </span>
            </div>
            <KTNotificationsMenu></KTNotificationsMenu>
        </div>-->
        <!--end::Notifications-->

        <!--begin::User-->
        <div class="d-flex align-items-center ms-1 ms-lg-3" id="kt_header_user_menu_toggle">
            <!--begin::Menu-->
            <div class="cursor-pointer symbol symbol-30px symbol-md-40px" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end" data-kt-menu-flip="bottom">
                <img src="/media/avatars/blank.png" alt="metronic"/>
            </div>
            <KTUserMenu></KTUserMenu>
            <!--end::Menu-->
        </div>
        <!--end::User -->

        <!--begin::Heaeder menu toggle-->
        <div class="d-none align-items-center d-lg-none ms-2 me-n3" title="Show header menu">
            <div class="btn btn-icon btn-active-light-primary" id="kt_header_menu_mobile_toggle">
                <span class="svg-icon svg-icon-1">
                    <inline-svg src="/media/icons/duotune/text/txt001.svg"/>
                </span>
            </div>
        </div>
        <!--end::Heaeder menu toggle-->
    </div>
    <!--end::Toolbar wrapper-->
</template>

<script>
import KTSearch from "@/layouts/header/partials/Search.vue";
import KTNotificationsMenu from "@/layouts/header/partials/NotificationsMenu.vue";
import KTUserMenu from "@/layouts/header/partials/UserMenu.vue";
import panelManager from "@/core/helpers/panelManager";

export default {
    name: "topbar",
    components: {
        KTSearch,
        KTNotificationsMenu,
        KTUserMenu
    },
    computed: {
        isMac() {
            return /Mac|iPod|iPhone|iPad/.test(navigator.platform)
        }
    },
    methods: {
        openSpotlight() {
            panelManager.openPanel('spotlight')
        },
    },
}
</script>

<style>
.topbar-spotlight-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border: 1px solid #e1e3ea;
    border-radius: 8px;
    background: #f5f5f7;
    color: #8e8e93;
    cursor: pointer;
    transition: all 0.15s;
    font-family: inherit;
}

.topbar-spotlight-btn:hover {
    background: #eaeaee;
    border-color: #d0d0d6;
    color: #636366;
}

.topbar-spotlight-btn svg {
    flex-shrink: 0;
}

.topbar-spotlight-shortcut {
    font-size: 11px;
    font-weight: 500;
    opacity: 0.6;
}

html.dark .topbar-spotlight-btn {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.1);
    color: #98989d;
}

html.dark .topbar-spotlight-btn:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.15);
    color: #c5c5ca;
}
</style>
